module.exports = __webpack_public_path__ + "static/media/bones.32331930.mp3";